<div [ngxTippy]="visible ? content : null" [tippyProps]="tippyProps">
  <ng-content></ng-content>
</div>
